import axios from 'axios'

export default {
    get: () => axios.get('asset-departaments'),
    getPublic: () => axios.get('asset-departaments-public'),
    store: (data) => axios.post('asset-departaments/store', data),
    update: (data) => axios.post('asset-departaments/update', data),
    delete: (id) => axios.post('asset-departaments/delete', id)
}